module.exports = __webpack_public_path__ + "static/media/nike-never-ask-khoreva.709fb200.mp4";